module.exports = __webpack_public_path__ + "static/img/new_0603-2.6a5d8c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/new_0603-2.png
// module id = OS5N
// module chunks = 1